export const alertHtml: any[] = [
  {
    h: "div",
    c: "sk-alert",
    id: "sk-alert",
    r: "elem",
    e: [
      {
        t: "mousewheel",
        r: "prevent",
        e: <T>(o: T): T => {
          return o;
        },
      },
      {
        t: "touchmove",
        r: "prevent",
        e: <T>(o: T): T => {
          return o;
        },
      },
      {
        t: "DOMMouseScroll",
        r: "prevent",
        e: <T>(o: T): T => {
          return o;
        },
      },
    ],
    s: [
      {
        h: "div",
        c: "sk-alert-wrap",
        r: "wrap",
        s: [
          {
            h: "div",
            c: "sk-alert-mian",
            lr: "html",
          },
          {
            h: "div",
            c: "sk-alert-footer",
            s: [
              {
                h: "div",
                c: "sk-alert-ok",
                lr: "okValue",
                e: [
                  {
                    t: "click",
                    f: "ok",
                    e: <T>(o: T): T => {
                      return o;
                    },
                  },
                ],
              },
              {
                h: "div",
                c: "sk-alert-no",
                lr: "noValue",
                cs: "confirm",
                e: [
                  {
                    t: "click",
                    f: "no",
                    e: <T>(o: T): T => {
                      return o;
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
